module.exports = __webpack_public_path__ + "static/media/ringtone.fa446f20.mp3";